import type { GridSortModel } from "@mui/x-data-grid-premium";

export interface ModuleListPaginationModel {
  page: number;
  pageSize: number;
}

export interface ModuleListGridState extends ModuleListPaginationModel {
  sortModel: GridSortModel;
}

const DEFAULT_MODULE_LIST_GRID_STATE: ModuleListGridState = {
  page: 0,
  pageSize: 10,
  sortModel: [],
};

const moduleListPaginationMemory: Record<string, ModuleListGridState> = {};

export const MODULE_LIST_PAGINATION_KEYS = {
  MENU_MANAGER: "menu-manager",
  WIZARD_MANAGER: "wizard-manager",
  FORM_MANAGER: "form-manager",
  GRID_MANAGER: "grid-manager",
} as const;

export function getModuleListGridState(key: string): ModuleListGridState {
  const state = moduleListPaginationMemory[key];
  if (!state) {
    return { ...DEFAULT_MODULE_LIST_GRID_STATE, sortModel: [] };
  }
  return {
    ...state,
    sortModel: [...state.sortModel],
  };
}

export function getModuleListPagination(
  key: string
): ModuleListPaginationModel {
  const { page, pageSize } = getModuleListGridState(key);
  return { page, pageSize };
}

export function getModuleListSortModel(key: string): GridSortModel {
  return getModuleListGridState(key).sortModel;
}

export function setModuleListPagination(
  key: string,
  model: ModuleListPaginationModel
): void {
  const current = getModuleListGridState(key);
  moduleListPaginationMemory[key] = { ...current, ...model };
}

export function setModuleListSortModel(
  key: string,
  sortModel: GridSortModel
): void {
  const current = getModuleListGridState(key);
  moduleListPaginationMemory[key] = { ...current, sortModel: [...sortModel] };
}

export function clearModuleListPaginationMemory(): void {
  Object.keys(moduleListPaginationMemory).forEach((key) => {
    delete moduleListPaginationMemory[key];
  });
}
